module.exports = __webpack_public_path__ + "a2408ad58c203664d3e809b5cd406ba7.jpg";